// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2ldX6","error":"Textarea_error__2hGqm","readonly":"Textarea_readonly__1rtEa","disabled":"Textarea_disabled__1idm3"};